import axios from 'axios'
import { get } from 'lodash'
import UrlPattern from 'url-pattern/lib/url-pattern'
const PROTECTED_ROUTES = ['index', 'create', 'update', 'delete']

/**
 * evaluate seo query (url.defaults)
 * @param idUrl
 * @param params
 * @returns {Promise<*>}
 */
async function getSeoRoute (idUrl, params) {
  let result
  result = await axios
    .get(`/api/Urls/resolve-seo-route`, {
      params: {
        idUrl,
        params: JSON.stringify(params)
      }
    })
  return get(result, 'data', {})
}

/**
 * match and query url with route parameters
 * @param url
 * @param seoUrls
 * @returns {Promise<{}>}
 */
async function resolveSeoRoute(url, seoUrls) {
  let retParams = []
  let retUrl = {}

  for (const item of seoUrls) {
    if (item.url) {
      // @regex match if string contains uri route parameter
      const itemUrl = item.url.indexOf('/') !== 0 ? `/${item.url}` : item.url
      const pattern = new UrlPattern(itemUrl, { segmentNameCharset: 'a-zA-Z0-9_-' })
      const match = pattern.match(url) || pattern.match(`/${url}`)

      if (!match) continue

      retUrl = item
      const seoObject = await getSeoRoute(item.idUrl, match)

      if (!seoObject) continue

      const seoRoute = seoObject.queryObject
      let notProtected = 0
      for (const route of Object.keys(match)) {
        if (PROTECTED_ROUTES.includes(match[route])) continue
        notProtected++
        break
      }

      if (!notProtected) continue

      for (const paramName of Object.keys(seoRoute)) {
        retParams.push(`${paramName}=${seoRoute[paramName]}`)
      }
    }
  }

  if (retParams.length) {
    const retParameters = retParams.join('&')
    retUrl.route = url.indexOf('/') === 0 ? `/${retUrl.route}` : retUrl.route
    url = `${retUrl.route}?${retParameters}&idUrl=${retUrl.idUrl}`
  }

  return { url, route: retUrl.route }
}

export {
  resolveSeoRoute
}
